import { render, staticRenderFns } from "./HeaderExtract.vue?vue&type=template&id=72f9527a&scoped=true"
import script from "./HeaderExtract.vue?vue&type=script&lang=js"
export * from "./HeaderExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9527a",
  null
  
)

export default component.exports